<template>
  <div class="slide" v-parallax-fit="overlay"></div>
</template>

<script>
export default {
  name: 'black_overlay',
  props: {
  	overlay: {
  		type: Array,
  		required: false
  	}
  }
}
</script>

<style lang="scss" scoped>
.slide {
  pointer-events: none;
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  transition: 0.2s;
  z-index: 15;
  background-color: #000;
  // mix-blend-mode: color-burn;
}
</style>
